import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/views/admin/login/login.vue'
import Inscription from '@/views/admin/Inscription/Inscription.vue'
import Home from '@/views/Magasin/Home/Home.vue'
import Magasin from '@/views/Magasin/Magasin.vue'
import Management from '@/views/admin/management/management.vue'
import Categorie from '@/views/Magasin/Categorie/Categorie.vue'
import Famille from '@/views/Magasin/Famille/Famille.vue'
import Produit from '@/views/Magasin/Produit/Produit.vue'
import Panier from '@/views/Magasin/Panier/Panier.vue'
import Commande from '@/views/Magasin/Commande/Commande.vue'
import CommandeSuccess from '@/views/Magasin/Commande/CommandeSuccess/CommandeSuccess.vue'
import Contact from '@/views/Magasin/Contact/Contact.vue'
import ForgetPassword from '@/views/admin/ForgetPassword/ForgetPassword.vue'
import ResetPassword from '@/views/admin/ResetPassword/ResetPassword.vue'
import ConfirmInscription from '@/views/admin/ConfirmInscription/ConfirmInscription.vue'
import MonCompte from '@/views/Magasin/MonCompte/MonCompte.vue'
import aPropos from '@/views/Magasin/APropos/APropos.vue'
import store from '@/store/index.js'

const routes = [{
    path: '*',
    redirect: '/home'
  },
  {
    path: '/loginAdmin',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: Magasin,
    children: [{
        path: '',
        name: 'Home',
        component: Home
      },
      {
        path: '/login',
        name: 'Inscription',
        component: Inscription
      },
      {
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: ForgetPassword
      },
      {
        path: '/resetpassword/:uniqueCode',
        name: 'resetPassword',
        component: ResetPassword
      },
      {
        path: '/confirmregister/:uniqueCode',
        name: 'confirmRegister',
        component: ConfirmInscription
      },
      {
        path: '/categorie/:catId',
        name: 'Categorie',
        component: Categorie
      },
      {
        path: '/categorie/:catId/famille/:famId',
        name: 'Famille',
        component: Famille
      },
      {
        path: '/categorie/:catId/famille/:famId/produit/:prodId',
        name: 'Produit',
        component: Produit
      },
      {
        path: '/panier',
        name: 'Panier',
        component: Panier
      },
      {
        path: '/commande',
        name: 'Commande',
        component: Commande,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/commandeSuccess',
        name: 'CommandeSuccess',
        component: CommandeSuccess,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/contact',
        name: 'Contact',
        component: Contact
      },
      {
        path: '/apropos',
        name: 'aPropos',
        component: aPropos
      },
      {
        path: '/mon-compte',
        name: 'MonCompte',
        component: MonCompte,
        meta: {
          requiresAuth: true,
        },
      },
    ]
  },
  {
    path: '/management',
    name: 'Management',
    component: Management,
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    },
  },

]

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  history: true,
  routes
})

// Check auth before each routes
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token')) {
      if (to.matched.some(record => record.meta.requiresAdmin)) {
        if (router.app.$store.getters.user && router.app.$store.getters.user.role === 'admin') {
          next()
        } else {
          router.app.$store._actions.getUser[0]().then(() => {
            next()
          }).catch(() => {
            next('/')
          })
        }
      } else if (to.matched.some(record => record.meta.requiresAuth)) {
        if (router.app.$store.getters.user) {
          next()
        } else {
          router.app.$store._actions.getUser[0]().then(() => {
            next()
          }).catch(() => {
            next('/')
          })
        }
      } else {
        next()
      }
      return
    } else {
      if (from.name == 'Management') {
        next('/loginAdmin')
      } else {
        next('/login')
      }
    }
  } else {
    next()
  }
})

export default router